import { Observable } from 'rxjs';
import { Papa } from 'ngx-papaparse';
import * as i0 from "@angular/core";
import * as i1 from "ngx-papaparse";
var ExportFieldConfig = /** @class */ (function () {
    function ExportFieldConfig() {
    }
    return ExportFieldConfig;
}());
export { ExportFieldConfig };
var ExportService = /** @class */ (function () {
    function ExportService(papa) {
        this.papa = papa;
    }
    ExportService.prototype.importCSV = function (csv) {
        var _this = this;
        return new Observable(function (observer) {
            var _a = _this.papa.parse(csv), data = _a.data, errors = _a.errors;
            if (errors.length) {
                observer.error(errors);
                observer.complete();
            }
            else {
                observer.next(data);
                observer.complete();
            }
        });
    };
    ExportService.prototype.exportCSV = function (rows, columns, includeHeader) {
        var _this = this;
        if (includeHeader === void 0) { includeHeader = true; }
        var exportRows = [];
        // #TODO: [AC] - ngx-papaparse wrapper doesn't support explicit header columns, manually build rows[]
        // add header
        if (includeHeader) {
            exportRows.push(columns.map(function (c) { return c.label; }));
        }
        // add data rows
        rows.forEach(function (row) {
            var dataRow = columns.map(function (col) { return row[col.field]; });
            exportRows.push(dataRow);
        });
        return new Observable(function (observer) {
            var csv = _this.papa.unparse(exportRows, { quotes: true, header: false });
            observer.next(csv);
            observer.complete();
        });
    };
    ExportService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExportService_Factory() { return new ExportService(i0.ɵɵinject(i1.Papa)); }, token: ExportService, providedIn: "root" });
    return ExportService;
}());
export { ExportService };
